// deploy: 1778048800
/* ============================================================================
 * Viori Personalizer 2.0 — V6 Filter Controller
 *
 * Source of truth: URL params. No localStorage, no sessionStorage, no cookies.
 *
 * URL param convention:
 *   ?sort_by=Best+Sellers
 *   ?scalp_type=Oily,Normal
 *   ?concern=Thinning+Hair
 *   ?benefit=Growth
 *   ?product_type=Shampoo,Conditioner
 *
 * Values are stored Title Case exactly as they appear in Shopify metafield
 * definitions (e.g. "Oily", "Thinning Hair").
 *
 * Public API — window.VioriFilters:
 *   getState()                 → { sort_by, scalp_types[], concerns[], benefits[], product_types[] }
 *   setState(partial)          → merges, writes URL, notifies
 *   toggle(category, value)    → toggles value in multi-select category
 *   setSort(value)             → sets sort_by
 *   clearCategory(category)    → clears one category
 *   clearAll()                 → clears all filters
 *   subscribe(cb)              → cb(state) on every change; returns unsubscribe
 *   activeCount(category)      → number of active values
 *   totalActive()              → total active across all categories
 *   bindFilterBar(rootEl)      → wires up a filter-bar section's DOM
 *
 * Rules (per CLAUDE.md):
 *   - history.replaceState for URL writes
 *   - debounce 500ms for rapid selections
 *   - do NOT fire on popstate (back/forward)
 *   - deduplicate: only notify when state key changes
 * ========================================================================== */

(function (window, document) {
  'use strict';

  if (window.VioriFilters) return;

  var MULTI_KEYS = ['scalp_types', 'concerns', 'benefits', 'product_types', 'hair_likenesses', 'scents', 'shopping_missions'];
  var URL_KEY_MAP = {
    sort_by:            'sort_by',
    scalp_types:        'scalp_type',
    concerns:           'concern',
    benefits:           'benefit',
    product_types:      'product_type',
    hair_likenesses:    'hair_likeness',
    scents:             'scent',
    shopping_missions:  'shopping_mission'
  };
  // Functional sorts use Shopify's native sort_by URL param (price-ascending / price-descending)
  // instead of filtering by custom.product_status metafield.
  var FUNCTIONAL_SORT_MAP = {
    'Price: Low → High': 'price-ascending',
    'Price: High → Low': 'price-descending'
  };
  function isFunctionalSort(v) { return v && FUNCTIONAL_SORT_MAP.hasOwnProperty(v); }

  // Mapping between singular pill keys and plural state keys.
  var PILL_TO_STATE = {
    sort_by:           'sort_by',
    scalp_type:        'scalp_types',
    concern:           'concerns',
    benefit:           'benefits',
    product_type:      'product_types',
    hair_likeness:     'hair_likenesses',
    scent:             'scents',
    shopping_mission:  'shopping_missions'
  };

  var state = {
    sort_by: '',
    scalp_types: [],
    concerns: [],
    benefits: [],
    product_types: [],
    hair_likenesses: [],
    scents: [],
    shopping_missions: []
  };

  var subscribers = [];
  var lastFiredKey = '';
  var debounceTimer = null;
  var DEBOUNCE_MS = 500;

  // ──── URL <-> state ────────────────────────────────────────────────────
  function splitCSV(str) {
    if (!str) return [];
    return str.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  // Maps Shopify storefront filter URL params → V6 plural state key, so an
  // external link landing with `filter.p.m.custom.scalp_type=Oily` (the form
  // emitted by hero CTAs, ad URLs, and bot directives) hydrates state just
  // like the V6-short form (`scalp_type=Oily`).
  var SHOPIFY_PARAM_TO_STATE = {
    'filter.p.m.custom.scalp_type':         'scalp_types',
    'filter.p.m.custom.shop_by_concern':    'concerns',
    'filter.p.m.custom.shop_by_benefit':    'benefits',
    'filter.p.product_type':                'product_types',
    'filter.p.m.custom.hair_likeness':      'hair_likenesses',
    'filter.p.m.custom.product_scent':      'scents',
    'filter.p.m.custom.shopping_mission':   'shopping_missions'
  };

  function readStateFromURL() {
    var p = new URLSearchParams(window.location.search);
    state = {
      sort_by:           p.get(URL_KEY_MAP.sort_by) || '',
      scalp_types:       splitCSV(p.get(URL_KEY_MAP.scalp_types)),
      concerns:          splitCSV(p.get(URL_KEY_MAP.concerns)),
      benefits:          splitCSV(p.get(URL_KEY_MAP.benefits)),
      product_types:     splitCSV(p.get(URL_KEY_MAP.product_types)),
      hair_likenesses:   splitCSV(p.get(URL_KEY_MAP.hair_likenesses)),
      scents:            splitCSV(p.get(URL_KEY_MAP.scents)),
      shopping_missions: splitCSV(p.get(URL_KEY_MAP.shopping_missions))
    };
    // Union in any Shopify-format params present on the URL (external link
    // landings). Shopify storefront filter API supports the same param key
    // repeated for multi-select (filter.p.m.custom.scalp_type=Oily&
    // filter.p.m.custom.scalp_type=Dry), so use getAll().
    Object.keys(SHOPIFY_PARAM_TO_STATE).forEach(function (shopifyKey) {
      var stateKey = SHOPIFY_PARAM_TO_STATE[shopifyKey];
      var vals = p.getAll(shopifyKey);
      if (!vals || !vals.length) return;
      var arr = state[stateKey];
      vals.forEach(function (v) {
        v = (v || '').trim();
        if (v && arr.indexOf(v) === -1) arr.push(v);
      });
    });
  }

  function writeStateToURL() {
    var p = new URLSearchParams(window.location.search);
    if (state.sort_by) p.set(URL_KEY_MAP.sort_by, state.sort_by);
    else               p.delete(URL_KEY_MAP.sort_by);
    MULTI_KEYS.forEach(function (k) {
      var urlKey = URL_KEY_MAP[k];
      if (state[k] && state[k].length) p.set(urlKey, state[k].join(','));
      else                             p.delete(urlKey);
    });
    // Strip any Shopify-format keys we may have hydrated from on first
    // paint. State has been authored to V6-short form above; leaving the
    // Shopify-format duplicates would double-apply on the next SRA fetch.
    Object.keys(SHOPIFY_PARAM_TO_STATE).forEach(function (k) { p.delete(k); });
    // Filter changes always reset pagination to page 1. Drop the page
    // param so re-applied filters don't leave the user stranded on an
    // invalid page index.
    p.delete('page');
    var qs = p.toString();
    var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }

  // ──── Notify ───────────────────────────────────────────────────────────
  function stateKey() {
    return JSON.stringify({
      s: state.sort_by,
      t: state.scalp_types.slice().sort(),
      c: state.concerns.slice().sort(),
      b: state.benefits.slice().sort(),
      p: state.product_types.slice().sort(),
      h: state.hair_likenesses.slice().sort(),
      e: state.scents.slice().sort(),
      m: state.shopping_missions.slice().sort()
    });
  }

  function notify() {
    var key = stateKey();
    if (key === lastFiredKey) return;
    lastFiredKey = key;
    var snap = getState();
    subscribers.forEach(function (cb) {
      try { cb(snap); } catch (e) { console.error('[VioriFilters] subscriber threw:', e); }
    });
    window.dispatchEvent(new CustomEvent('vioriFiltersChanged', { detail: snap }));
  }

  function scheduleNotify() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      writeStateToURL();
      notify();
    }, DEBOUNCE_MS);
  }

  // ──── Public API ───────────────────────────────────────────────────────
  function getState() {
    return {
      sort_by:           state.sort_by,
      scalp_types:       state.scalp_types.slice(),
      concerns:          state.concerns.slice(),
      benefits:          state.benefits.slice(),
      product_types:     state.product_types.slice(),
      hair_likenesses:   state.hair_likenesses.slice(),
      scents:            state.scents.slice(),
      shopping_missions: state.shopping_missions.slice()
    };
  }

  function setState(partial) {
    if (!partial) return;
    if (typeof partial.sort_by === 'string') state.sort_by = partial.sort_by;
    MULTI_KEYS.forEach(function (k) {
      if (Array.isArray(partial[k])) state[k] = partial[k].slice();
    });
    scheduleNotify();
  }

  function toggle(category, value) {
    if (MULTI_KEYS.indexOf(category) === -1) return;
    var arr = state[category];
    var i = arr.indexOf(value);
    if (i === -1) arr.push(value);
    else          arr.splice(i, 1);
    scheduleNotify();
  }

  function setSort(value) {
    state.sort_by = value || '';
    scheduleNotify();
  }

  function clearCategory(category) {
    if (category === 'sort_by') state.sort_by = '';
    else if (MULTI_KEYS.indexOf(category) !== -1) state[category] = [];
    else return;
    scheduleNotify();
  }

  function clearAll() {
    state.sort_by = '';
    MULTI_KEYS.forEach(function (k) { state[k] = []; });
    scheduleNotify();
  }

  // ──── External applyFilters adapter ────────────────────────────────────
  // Used by external surfaces (the Beauty Expert chatbot) to write filters
  // into V6 state. The bot's worker emits keys in Shopify storefront URL
  // format ("filter.p.m.custom.scalp_type"); this adapter translates those
  // to V6 state keys ("scalp_types") and writes them.
  //
  // Skipped keys (categories V6 doesn't track) are logged to the console
  // via console.warn so misconfigured or hallucinated filter values are
  // diagnosable in DevTools.
  var BOT_KEY_TO_STATE = {
    // Shopify filter URL format → V6 plural state key.
    // NOTE: product_type is a NATIVE Shopify filter (`filter.p.product_type`),
    // not a metafield (no `.m.custom.` segment). The bot's worker prompt
    // (be.v1.7+) writes the native key. Keep the native key wired here; the
    // legacy `.m.custom.product_type` key is also accepted as a forgiveness
    // alias in case an older worker build is still on the wire.
    'filter.p.m.custom.scalp_type':         'scalp_types',
    'filter.p.m.custom.shop_by_concern':    'concerns',
    'filter.p.m.custom.shop_by_benefit':    'benefits',
    'filter.p.product_type':                'product_types',
    'filter.p.m.custom.product_type':       'product_types',
    'filter.p.m.custom.hair_likeness':      'hair_likenesses',
    'filter.p.m.custom.product_scent':      'scents',
    'filter.p.m.custom.shopping_mission':   'shopping_missions',
    // Singular pill keys → plural state key
    'scalp_type':         'scalp_types',
    'shop_by_concern':    'concerns',
    'shop_by_benefit':    'benefits',
    'product_type':       'product_types',
    'hair_likeness':      'hair_likenesses',
    'product_scent':      'scents',
    'scent':              'scents',
    'shopping_mission':   'shopping_missions',
    // sort_by passthrough (the apply path also recognises this; see below)
    'sort_by':            'sort_by',
    // Already-plural state keys (passthrough)
    'scalp_types':        'scalp_types',
    'concerns':           'concerns',
    'benefits':           'benefits',
    'product_types':      'product_types',
    'hair_likenesses':    'hair_likenesses',
    'scents':             'scents',
    'shopping_missions':  'shopping_missions'
  };

  function applyFilters(opts) {
    opts = opts || {};
    var filters = opts.filters || {};
    var clear   = opts.clear   || [];
    var merge   = opts.merge !== false; // default true
    var source  = opts.source  || 'external';
    var changed = false;
    var skipped = [];

    // Phase 1 — clear specified categories
    for (var i = 0; i < clear.length; i++) {
      var ck = BOT_KEY_TO_STATE[clear[i]] || clear[i];
      if (ck === 'sort_by') { state.sort_by = ''; changed = true; }
      else if (MULTI_KEYS.indexOf(ck) !== -1) { state[ck] = []; changed = true; }
      else { skipped.push(clear[i]); }
    }

    // Phase 2 — apply new values
    Object.keys(filters).forEach(function (botKey) {
      var stateKey = BOT_KEY_TO_STATE[botKey];
      if (!stateKey) {
        skipped.push(botKey);
        return;
      }
      var newVals = filters[botKey];
      // sort_by is a single string, not an array. Accept either a bare
      // string or a 1-element array (the bot worker emits the array form
      // for schema consistency with the multi-value lanes).
      if (stateKey === 'sort_by') {
        var sortVal = '';
        if (typeof newVals === 'string') sortVal = newVals;
        else if (Array.isArray(newVals) && newVals.length > 0) sortVal = String(newVals[0] || '');
        // Normalize sort_by to Shopify canonical keys. The bot worker
        // sometimes emits the human-readable display label ("Best Sellers",
        // "Top Rated") instead of the canonical "best-selling" / "rating"
        // values Shopify expects. Title Case display labels would survive
        // into buildShopifyFilterParams and produce an invalid sort_by
        // URL parameter ("?sort_by=Best%20Sellers"), which Shopify's
        // collection-page handler treats as no sort and can interact
        // poorly with native filter math. Map every reasonable variant
        // to its canonical key here so the URL we send is always valid.
        var SORT_BY_NORMALIZE = {
          'best sellers':     'best-selling',
          'best-sellers':     'best-selling',
          'best seller':      'best-selling',
          'best-seller':      'best-selling',
          'best selling':     'best-selling',
          'best-selling':     'best-selling',
          'bestselling':      'best-selling',
          'most popular':     'best-selling',
          'popular':          'best-selling',
          'top rated':        'rating',
          'top-rated':        'rating',
          'highest rated':    'rating',
          'highest-rated':    'rating',
          'rating':           'rating',
          'newest':           'created-descending',
          'new':              'created-descending',
          'newest first':     'created-descending',
          'oldest':           'created-ascending',
          'price low to high': 'price-ascending',
          'price-ascending':  'price-ascending',
          'price-asc':        'price-ascending',
          'price low':        'price-ascending',
          'price high to low':'price-descending',
          'price-descending': 'price-descending',
          'price-desc':       'price-descending',
          'price high':       'price-descending',
          'a-z':              'title-ascending',
          'title-ascending':  'title-ascending',
          'z-a':              'title-descending',
          'title-descending': 'title-descending',
          'manual':           'manual',
          'featured':         'manual'
        };
        if (sortVal) {
          var normalized = SORT_BY_NORMALIZE[sortVal.toLowerCase().trim()];
          state.sort_by = normalized || sortVal;
          changed = true;
        }
        return;
      }
      if (MULTI_KEYS.indexOf(stateKey) === -1) {
        skipped.push(botKey);
        return;
      }
      if (!Array.isArray(newVals) || newVals.length === 0) return;
      if (merge) {
        var existing = state[stateKey] || [];
        for (var j = 0; j < newVals.length; j++) {
          if (existing.indexOf(newVals[j]) === -1) existing.push(newVals[j]);
        }
        state[stateKey] = existing;
      } else {
        state[stateKey] = newVals.slice();
      }
      changed = true;
    });

    if (skipped.length > 0) {
      console.warn('[VioriFilters] applyFilters from "' + source + '" skipped unknown keys:', skipped);
    }
    if (changed) {
      console.log('[VioriFilters] applyFilters from "' + source + '" wrote state:', getState());
      scheduleNotify();
    }
    return { changed: changed, skipped: skipped };
  }

  function subscribe(cb) {
    if (typeof cb !== 'function') return function () {};
    subscribers.push(cb);
    try { cb(getState()); } catch (e) { console.error('[VioriFilters] subscriber threw on init:', e); }
    return function () {
      var i = subscribers.indexOf(cb);
      if (i !== -1) subscribers.splice(i, 1);
    };
  }

  function activeCount(category) {
    if (category === 'sort_by') return state.sort_by ? 1 : 0;
    if (state[category] && Array.isArray(state[category])) return state[category].length;
    // allow passing pill-key form (singular) too
    var mapped = PILL_TO_STATE[category];
    if (mapped && state[mapped]) {
      return mapped === 'sort_by' ? (state.sort_by ? 1 : 0) : state[mapped].length;
    }
    return 0;
  }

  function totalActive() {
    return (state.sort_by ? 1 : 0) +
           state.scalp_types.length +
           state.concerns.length +
           state.benefits.length +
           state.product_types.length +
           state.hair_likenesses.length +
           state.scents.length +
           state.shopping_missions.length;
  }

  // ──── Filter bar UI binder ─────────────────────────────────────────────
  function bindFilterBar(root) {
    if (!root || root.__vioriBound) return;
    root.__vioriBound = true;

    var pills           = root.querySelectorAll('[data-v-pill]');
    var popovers        = root.querySelectorAll('[data-v-popover]');
    var popoverBackdrop = root.querySelector('[data-v-popover-backdrop]');
    var sheetBackdrop   = root.querySelector('[data-v-sheet-backdrop]');
    var sheet           = root.querySelector('[data-v-sheet]');
    var sheetOpenBtn    = root.querySelector('[data-action="open-sheet"]');
    var sheetCloseBtn   = root.querySelector('[data-action="close-sheet"]');
    var sheetApplyBtn   = root.querySelector('[data-action="apply-sheet"]');
    var sheetResetBtn   = root.querySelector('[data-action="reset-sheet"]');
    var clearAllBtn     = root.querySelector('[data-action="clear-all"]');
    var chipList        = root.querySelector('[data-v6-chip-list]');
    var productCountEl  = root.querySelector('[data-v6-product-count]');
    var activeRow       = root.querySelector('[data-v6-active-row]');

    var stagedPopover = {};
    var stagedSheet   = null;

    // ──── Popover ────
    // On mobile, move the popover out of the scroll container so it isn't clipped
    var filterBarWrap = root.querySelector('.v-filterbar') || root;

    function openPopover(category) {
      closeAllPopovers();
      var popover = findPopover(category);
      var pill    = root.querySelector('[data-v-pill="' + category + '"]');
      if (!popover || !pill) return;

      // Bryce 2026-05-05: portal-mount the popover onto document.body for
      // BOTH mobile and desktop so it escapes every ancestor stacking
      // context (section containers, sticky filter wrap, theme wrappers).
      // Without this, popovers fall behind sibling sections like Top
      // Matches whose titles paint in a higher-priority context.
      if (popover.parentNode !== document.body) {
        document.body.appendChild(popover);
      }
      var barRect  = root.getBoundingClientRect();
      var pillRect = pill.getBoundingClientRect();

      if (window.innerWidth < 750) {
        // Mobile: full-width sheet under the filter bar.
        popover.style.position = 'fixed';
        popover.style.top = barRect.bottom + 'px';
        popover.style.left = '12px';
        popover.style.right = '12px';
        popover.style.bottom = 'auto';
        popover.style.maxWidth = 'none';
        popover.style.minWidth = '0';
        popover.style.zIndex = '9999';
      } else {
        // Desktop: anchor below the host pill, left-aligned. Clamp to
        // viewport so a long popover near the right edge doesn't overflow.
        var POP_MIN_W = 260;
        var GUTTER = 12;
        var leftPx = pillRect.left;
        var maxLeft = window.innerWidth - POP_MIN_W - GUTTER;
        if (leftPx > maxLeft) leftPx = Math.max(GUTTER, maxLeft);
        popover.style.position = 'fixed';
        popover.style.top = (pillRect.bottom + 8) + 'px';
        popover.style.left = leftPx + 'px';
        popover.style.right = 'auto';
        popover.style.bottom = 'auto';
        popover.style.zIndex = '9999';
      }

      stagedPopover[category] = snapshotPillCategory(category);
      syncPopoverInputs(category);
      popover.setAttribute('aria-hidden', 'false');
      popover.classList.add('is-open');
      pill.setAttribute('aria-expanded', 'true');
      pill.classList.add('is-active');
      if (popoverBackdrop) popoverBackdrop.hidden = false;
    }
    function findPopover(category) {
      return root.querySelector('[data-v-popover="' + category + '"]')
          || document.querySelector('body > [data-v-popover="' + category + '"]');
    }

    function closeAllPopovers() {
      document.querySelectorAll('[data-v-popover]').forEach(function (p) {
        p.setAttribute('aria-hidden', 'true');
        p.classList.remove('is-open');
      });
      root.querySelectorAll('[data-v-pill]').forEach(function (p) {
        p.setAttribute('aria-expanded', 'false');
        p.classList.remove('is-active');
      });
      if (popoverBackdrop) popoverBackdrop.hidden = true;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var category = pill.getAttribute('data-v-pill');
        if (window.innerWidth < 750) {
          openSheet(null, category);
          return;
        }
        var popover = findPopover(category);
        if (popover && popover.classList.contains('is-open')) closeAllPopovers();
        else openPopover(category);
      });
    });

    if (popoverBackdrop) popoverBackdrop.addEventListener('click', closeAllPopovers);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAllPopovers(); closeSheet(); }
    });

    popovers.forEach(function (popover) {
      var category = popover.getAttribute('data-v-popover');
      popover.addEventListener('change', function (e) {
        var input = e.target;
        if (!input.matches('[data-option]')) return;
        var parentOpt = input.closest('.v-popover__option');
        if (parentOpt && parentOpt.getAttribute('aria-disabled') === 'true') {
          input.checked = false;
          return;
        }
        var value = input.value;
        if (category === 'sort_by') {
          stagedPopover[category].sort_by = input.checked ? value : '';
        } else {
          var arr = stagedPopover[category].values;
          var i = arr.indexOf(value);
          if (input.checked && i === -1) arr.push(value);
          else if (!input.checked && i !== -1) arr.splice(i, 1);
        }
        // Toggle --checked class on parent label for CSS styling
        var label = input.closest('.v-popover__option');
        if (label) label.classList.toggle('v-popover__option--checked', input.checked);
        updatePopoverApplyCount(category);
      });

      var clearBtn = popover.querySelector('[data-action="clear-category"]');
      if (clearBtn) clearBtn.addEventListener('click', function () {
        stagedPopover[category] = { sort_by: '', values: [] };
        syncPopoverInputs(category);
        updatePopoverApplyCount(category);
      });

      // "Clear all filters" link inside each popover header — wipes the
      // entire filter state across all categories, then closes the popover.
      var clearAllInPopoverBtn = popover.querySelector('[data-action="clear-all-filters"]');
      if (clearAllInPopoverBtn) clearAllInPopoverBtn.addEventListener('click', function () {
        clearAll();
        stagedPopover = {};
        closeAllPopovers();
      });

      var applyBtn = popover.querySelector('[data-action="apply-popover"]');
      if (applyBtn) applyBtn.addEventListener('click', function () {
        commitPillCategory(category, stagedPopover[category]);
        closeAllPopovers();
      });
    });

    // ──── Sheet ────
    function openSheet(scrollToCategory, singleCategory) {
      stagedSheet = snapshotAll();
      syncSheetInputs();

      // If a single category is requested, hide all other groups
      var allGroups = sheet ? sheet.querySelectorAll('[data-sheet-group]') : [];
      var sheetTitle = sheet ? sheet.querySelector('.v-sheet__title') : null;
      allGroups.forEach(function (g) {
        if (singleCategory) {
          g.style.display = g.getAttribute('data-sheet-group') === singleCategory ? '' : 'none';
        } else {
          g.style.display = '';
        }
      });
      if (sheetTitle) {
        if (singleCategory) {
          var visibleGroup = sheet.querySelector('[data-sheet-group="' + singleCategory + '"] .v-sheet__group-title');
          sheetTitle.textContent = visibleGroup ? visibleGroup.textContent : 'Filters';
        } else {
          sheetTitle.textContent = 'Filters';
        }
      }

      // Move sheet + backdrop to document.body so they escape the
      // filter bar's stacking context (position:sticky z-index:99)
      if (sheetBackdrop && sheetBackdrop.parentNode !== document.body) {
        document.body.appendChild(sheetBackdrop);
      }
      if (sheet && sheet.parentNode !== document.body) {
        document.body.appendChild(sheet);
      }
      if (sheetBackdrop) sheetBackdrop.hidden = false;
      if (sheet) {
        sheet.hidden = false;
        sheet.classList.add('is-open');
        sheet.setAttribute('aria-hidden', 'false');
      }
      document.body.style.overflow = 'hidden';
      if (scrollToCategory && sheet) {
        var group = root.querySelector('[data-sheet-group="' + scrollToCategory + '"]');
        var body = sheet.querySelector('[data-v-sheet-body]');
        if (group && body) {
          var headH = 0;
          var head = sheet.querySelector('[data-v-sheet-head]');
          if (head) headH = head.offsetHeight;
          body.scrollTop = Math.max(group.offsetTop - headH, 0);
        }
      }
    }
    function closeSheet() {
      if (sheetBackdrop) sheetBackdrop.hidden = true;
      if (sheet) {
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden', 'true');
        setTimeout(function () { sheet.hidden = true; }, 200);
      }
      document.body.style.overflow = '';
    }

    if (sheetOpenBtn)  sheetOpenBtn.addEventListener('click', function () { openSheet(null, null); });
    if (sheetCloseBtn) sheetCloseBtn.addEventListener('click', closeSheet);
    if (sheetBackdrop) sheetBackdrop.addEventListener('click', closeSheet);

    if (sheet) {
      sheet.addEventListener('change', function (e) {
        var input = e.target;
        if (!input.matches('[data-sheet-option]')) return;
        var parentLabel = input.closest('.v-sheet__radio');
        if (parentLabel && parentLabel.getAttribute('aria-disabled') === 'true') {
          input.checked = false;
          return;
        }
        var category = input.getAttribute('data-category');
        var value = input.value;
        if (category === 'sort_by') {
          stagedSheet.sort_by = input.checked ? value : '';
        } else {
          var stateKey = PILL_TO_STATE[category];
          var arr = stagedSheet[stateKey];
          var i = arr.indexOf(value);
          if (input.checked && i === -1) arr.push(value);
          else if (!input.checked && i !== -1) arr.splice(i, 1);
        }
      });
      sheet.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-sheet-chip]');
        if (!chip) return;
        if (chip.getAttribute('aria-disabled') === 'true') return;
        var category = chip.getAttribute('data-category');
        var stateKey = PILL_TO_STATE[category];
        var value = chip.getAttribute('data-value');
        var arr = stagedSheet[stateKey];
        var i = arr.indexOf(value);
        if (i === -1) { arr.push(value); chip.classList.add('is-active'); }
        else          { arr.splice(i, 1); chip.classList.remove('is-active'); }
      });
    }

    if (sheetResetBtn) sheetResetBtn.addEventListener('click', function () {
      stagedSheet = { sort_by: '', scalp_types: [], concerns: [], benefits: [], product_types: [], hair_likenesses: [], scents: [], shopping_missions: [] };
      syncSheetInputs();
    });
    if (sheetApplyBtn) sheetApplyBtn.addEventListener('click', function () {
      setState(stagedSheet);
      closeSheet();
    });

    // "Clear all" link inside sheet header (mobile) — wipes committed
    // state across all categories AND staged sheet state, then closes
    // the sheet immediately.
    //
    // Force-hide explicitly: the global rule .v-sheet { display: flex }
    // in cust-v6-components.css.liquid can shadow the local default
    // `display: none`, so removing .is-open is not sufficient on its own.
    // Setting `hidden = true` triggers `.v-sheet[hidden] { display: none !important }`
    // which guarantees the sheet visually closes.
    if (sheet) {
      var sheetClearAllBtn = sheet.querySelector('[data-action="clear-all-filters"]');
      if (sheetClearAllBtn) sheetClearAllBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearAll();
        stagedSheet = { sort_by: '', scalp_types: [], concerns: [], benefits: [], product_types: [], hair_likenesses: [], scents: [], shopping_missions: [] };
        try { syncSheetInputs(); } catch (_) {}
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden', 'true');
        sheet.hidden = true;
        if (sheetBackdrop) sheetBackdrop.hidden = true;
        document.body.style.overflow = '';
      });
    }

    // ──── Clear all ────
    if (clearAllBtn) clearAllBtn.addEventListener('click', function () { clearAll(); });

    // ──── Sync on state change ────
    subscribe(function () {
      // Pill count badges
      Object.keys(PILL_TO_STATE).forEach(function (pillKey) {
        var n = activeCount(pillKey);
        var countEl = root.querySelector('[data-count-for="' + pillKey + '"]');
        if (countEl) {
          countEl.textContent = n;
          countEl.hidden = n === 0;
        }
        var pillEl = root.querySelector('[data-v-pill="' + pillKey + '"]');
        if (pillEl) pillEl.classList.toggle('has-active', n > 0);
      });

      // Active chip row
      if (chipList) renderActiveChips();
      if (activeRow) {
        activeRow.hidden = totalActive() === 0;
      }
      if (clearAllBtn) clearAllBtn.hidden = totalActive() === 0;

      // Sort-by label on desktop sort button
      var sortLabelEl = root.querySelector('[data-v6-sort-label]');
      if (sortLabelEl) sortLabelEl.textContent = state.sort_by || 'Recommended';
    });

    function renderActiveChips() {
      chipList.innerHTML = '';
      var groups = [
        { cat: 'scalp_type',       label: 'SCALP',    values: state.scalp_types },
        { cat: 'concern',          label: 'CONCERN',  values: state.concerns },
        { cat: 'benefit',          label: 'BENEFIT',  values: state.benefits },
        { cat: 'product_type',     label: 'TYPE',     values: state.product_types },
        { cat: 'hair_likeness',    label: 'HAIR',     values: state.hair_likenesses },
        { cat: 'scent',            label: 'SCENT',    values: state.scents },
        { cat: 'shopping_mission', label: 'SHOPPING', values: state.shopping_missions }
      ];
      groups.forEach(function (g) {
        g.values.forEach(function (v) {
          var chip = document.createElement('span');
          chip.className = 'v-chip v-chip--active';
          chip.setAttribute('data-chip-category', g.cat);
          chip.setAttribute('data-chip-value', v);
          chip.innerHTML = '<span class="v-chip__value">' + escapeHTML(v) + '</span>' +
                           '<button type="button" class="v-chip__x" aria-label="Remove ' + g.label + ' ' + escapeHTML(v) + ' filter">&times;</button>';
          chipList.appendChild(chip);
        });
      });
    }

    if (chipList) {
      chipList.addEventListener('click', function (e) {
        var x = e.target.closest('.v-chip__x');
        if (!x) return;
        var chip = x.closest('[data-chip-category]');
        if (!chip) return;
        var cat = chip.getAttribute('data-chip-category');
        var val = chip.getAttribute('data-chip-value');
        var stateKey = PILL_TO_STATE[cat];
        if (!stateKey || stateKey === 'sort_by') return;
        var arr = state[stateKey];
        var i = arr.indexOf(val);
        if (i !== -1) arr.splice(i, 1);
        scheduleNotify();
      });
    }

    function escapeHTML(s) {
      return String(s).replace(/[&<>"']/g, function (ch) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
      });
    }

    // ──── Helpers ────
    function snapshotPillCategory(pillKey) {
      var stateKey = PILL_TO_STATE[pillKey];
      if (stateKey === 'sort_by') return { sort_by: state.sort_by, values: [] };
      return { sort_by: '', values: state[stateKey] ? state[stateKey].slice() : [] };
    }

    function snapshotAll() {
      return {
        sort_by:           state.sort_by,
        scalp_types:       state.scalp_types.slice(),
        concerns:          state.concerns.slice(),
        benefits:          state.benefits.slice(),
        product_types:     state.product_types.slice(),
        hair_likenesses:   state.hair_likenesses.slice(),
        scents:            state.scents.slice(),
        shopping_missions: state.shopping_missions.slice()
      };
    }

    function syncPopoverInputs(category) {
      var popover = findPopover(category);
      if (!popover) return;
      var staged = stagedPopover[category];
      popover.querySelectorAll('[data-option]').forEach(function (input) {
        if (category === 'sort_by') input.checked = input.value === staged.sort_by;
        else                        input.checked = staged.values.indexOf(input.value) !== -1;
        var label = input.closest('.v-popover__option');
        if (label) label.classList.toggle('v-popover__option--checked', input.checked);
      });
      updatePopoverApplyCount(category);
    }

    function updatePopoverApplyCount(category) {
      var popover = findPopover(category);
      if (!popover) return;
      var staged = stagedPopover[category];
      var n = category === 'sort_by' ? (staged.sort_by ? 1 : 0) : staged.values.length;
      var countEl = popover.querySelector('[data-popover-apply-count]');
      if (countEl) countEl.textContent = n > 0 ? '· ' + n : '';
    }

    function syncSheetInputs() {
      if (!sheet) return;
      sheet.querySelectorAll('[data-sheet-option]').forEach(function (input) {
        var category = input.getAttribute('data-category');
        if (category === 'sort_by') input.checked = input.value === stagedSheet.sort_by;
        else {
          var sk = PILL_TO_STATE[category];
          input.checked = sk ? stagedSheet[sk].indexOf(input.value) !== -1 : false;
        }
      });
      sheet.querySelectorAll('[data-sheet-chip]').forEach(function (chip) {
        var category = chip.getAttribute('data-category');
        var sk = PILL_TO_STATE[category];
        var val = chip.getAttribute('data-value');
        var on = sk ? stagedSheet[sk].indexOf(val) !== -1 : false;
        chip.classList.toggle('is-active', on);
      });
    }

    function commitPillCategory(pillKey, staged) {
      var sk = PILL_TO_STATE[pillKey];
      if (sk === 'sort_by') state.sort_by = staged.sort_by || '';
      else                  state[sk] = staged.values.slice();
      scheduleNotify();
    }

    // ── Auto-sync filter options from Shopify's live metafield definitions ──
    // Fetches the current filter values + counts from the storefront API
    // and rebuilds all pills/popovers/sort-row to match. This ensures
    // new metafield values and reordering in admin show up automatically.
    fetchFilterDefs(function (defs) {
      if (defs) rebuildFilterUI(root, defs);
    });
  }

  // ──── Dynamic filter definitions ────────────────────────────────────────
  // Maps Shopify filter.param_name → our internal pill key
  var PARAM_TO_PILL = {
    'filter.p.m.custom.product_status':     'sort_by',
    'filter.p.m.custom.scalp_type':         'scalp_type',
    'filter.p.m.custom.shop_by_concern':    'concern',
    'filter.p.m.custom.shop_by_benefit':    'benefit',
    'filter.p.product_type':                'product_type',
    'filter.p.m.custom.hair_likeness':      'hair_likeness',
    'filter.p.m.custom.product_scent':      'scent',
    'filter.p.m.custom.shopping_mission':   'shopping_mission'
  };

  function fetchFilterDefs(callback) {
    var url = '/collections/all?sections=cust-v6-filter-data';
    // Preserve preview_theme_id for draft theme testing
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url += '&preview_theme_id=' + preview;

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json['cust-v6-filter-data'];
        if (!html) { callback(null); return; }
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var script = doc.querySelector('[data-v6-filter-defs]');
        if (!script) { callback(null); return; }
        try {
          var defs = JSON.parse(script.textContent);
          callback(defs);
        } catch (e) {
          console.error('[VioriFilters] Failed to parse filter defs:', e);
          callback(null);
        }
      })
      .catch(function (e) {
        console.error('[VioriFilters] Failed to fetch filter defs:', e);
        callback(null);
      });
  }

  function rebuildFilterUI(root, defs) {
    if (!defs || !defs.filters) return;

    defs.filters.forEach(function (filter) {
      var pillKey = PARAM_TO_PILL[filter.param];
      if (!pillKey) return;
      // Only include values with count > 0
      var liveValues = filter.values
        .filter(function (v) { return v.count > 0; })
        .map(function (v) { return v.label; });

      // For sort_by: always append functional sorts (price) at the end
      if (pillKey === 'sort_by') {
        Object.keys(FUNCTIONAL_SORT_MAP).forEach(function (label) {
          if (liveValues.indexOf(label) === -1) liveValues.push(label);
        });
      }

      if (liveValues.length === 0) return;

      // Rebuild popover body
      var popover = root.querySelector('[data-v-popover="' + pillKey + '"]');
      if (popover) {
        var body = popover.querySelector('.v-popover__body');
        if (body) {
          var isRadio = pillKey === 'sort_by';
          body.innerHTML = '';
          liveValues.forEach(function (val) {
            var label = document.createElement('label');
            label.className = 'v-popover__option';
            var inputType = isRadio ? 'radio' : 'checkbox';
            var nameAttr = isRadio ? ' name="v-popover-' + pillKey + '"' : '';
            var indicatorClass = isRadio ? 'v-popover__radio' : 'v-popover__check';
            label.innerHTML =
              '<input type="' + inputType + '"' + nameAttr + ' value="' + escapeHTMLAttr(val) + '" data-option>' +
              '<span class="' + indicatorClass + '" aria-hidden="true"></span>' +
              '<span>' + escapeHTMLContent(val) + '</span>';
            body.appendChild(label);
          });
        }
      }

      // Rebuild sheet group chips
      var sheetGroup = root.querySelector('[data-sheet-group="' + pillKey + '"]');
      if (sheetGroup) {
        if (pillKey === 'sort_by') {
          // Sort is radio in sheet
          var optionsDiv = sheetGroup.querySelector('.v-sheet__options');
          if (optionsDiv) {
            optionsDiv.innerHTML = '';
            liveValues.forEach(function (val) {
              var label = document.createElement('label');
              label.className = 'v-sheet__radio';
              label.innerHTML =
                '<input type="radio" name="v-sheet-sort_by" value="' + escapeHTMLAttr(val) + '" data-sheet-option data-category="sort_by">' +
                '<span class="v-sheet__radio-dot" aria-hidden="true"></span>' +
                '<span>' + escapeHTMLContent(val) + '</span>';
              optionsDiv.appendChild(label);
            });
          }
        } else {
          var chipsDiv = sheetGroup.querySelector('.v-sheet__options');
          if (chipsDiv) {
            chipsDiv.innerHTML = '';
            liveValues.forEach(function (val) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'v-chip v-chip--pickable';
              btn.setAttribute('data-sheet-chip', '');
              btn.setAttribute('data-category', pillKey);
              btn.setAttribute('data-value', val);
              btn.textContent = val;
              chipsDiv.appendChild(btn);
            });
          }
        }
      }

      // Rebuild sort row buttons
      if (pillKey === 'sort_by') {
        var sortRow = root.querySelector('.v-sortrow__scroll');
        if (sortRow) {
          sortRow.innerHTML = '';
          liveValues.forEach(function (val) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'v-sortrow__btn';
            btn.setAttribute('data-sort-btn', '');
            btn.setAttribute('data-sort-value', val);
            btn.textContent = val;
            sortRow.appendChild(btn);
          });
        }
      }
    });

    // Remove pills/groups for filters that returned zero values
    var allPillKeys = Object.keys(PARAM_TO_PILL).map(function (p) { return PARAM_TO_PILL[p]; });
    var activePillKeys = defs.filters
      .filter(function (f) { return PARAM_TO_PILL[f.param] && f.values.some(function (v) { return v.count > 0; }); })
      .map(function (f) { return PARAM_TO_PILL[f.param]; });

    allPillKeys.forEach(function (pk) {
      if (pk === 'sort_by') return; // always keep sort
      var pillHost = root.querySelector('[data-v-pill="' + pk + '"]');
      if (pillHost) {
        var host = pillHost.closest('.v-pill-host');
        if (host) host.style.display = activePillKeys.indexOf(pk) === -1 ? 'none' : '';
      }
    });

    // ── DOM reorder: pills follow Search & Discovery order ──
    // The hamburger (data-v-hamburger) owns Sort By and stays at slot 0;
    // every other S&D filter renders as a labelled pill to its right.
    // Walk defs.filters in S&D order and append each .v-pill-host to its
    // parent — appendChild on an already-attached node moves it to the
    // end, so the loop sorts the pill row in one pass.
    var pillRow = root.querySelector('.v-filterbar__pills');
    if (!pillRow) {
      var firstHost = root.querySelector('.v-pill-host');
      if (firstHost) pillRow = firstHost.parentNode;
    }
    if (pillRow) {
      defs.filters.forEach(function (filter) {
        var pillKey = PARAM_TO_PILL[filter.param];
        if (!pillKey || pillKey === 'sort_by') return;
        var pillBtn = pillRow.querySelector('[data-v-pill="' + pillKey + '"]');
        if (!pillBtn) return;
        var host = pillBtn.closest('.v-pill-host');
        if (host && host.parentNode === pillRow) pillRow.appendChild(host);
      });
    }

    // ── DOM reorder: sheet groups follow S&D order too ──
    // Mobile bottom-sheet groups mirror Row 1; sort_by group stays at top
    // (it's a separate radio group rendered first), then the multi-select
    // chip groups follow S&D order.
    var sheetBody = root.querySelector('[data-v-sheet-body], .v-sheet__body');
    if (sheetBody) {
      defs.filters.forEach(function (filter) {
        var pillKey = PARAM_TO_PILL[filter.param];
        if (!pillKey || pillKey === 'sort_by') return;
        var group = sheetBody.querySelector('[data-sheet-group="' + pillKey + '"]');
        if (group && group.parentNode === sheetBody) sheetBody.appendChild(group);
      });
    }
  }

  function bindSortRow(root) {
    // Use event delegation on the scroll container — survives button replacements
    var sortScroll = root.querySelector('.v-sortrow__scroll');
    if (!sortScroll || sortScroll._sortBound) return;
    sortScroll._sortBound = true;

    sortScroll.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sort-btn]');
      if (!btn) return;
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var val = btn.getAttribute('data-sort-value');
      var wasActive = btn.classList.contains('is-active');
      sortScroll.querySelectorAll('[data-sort-btn]').forEach(function (b) { b.classList.remove('is-active'); });
      if (!wasActive) {
        btn.classList.add('is-active');
        setSort(val);
      } else {
        setSort('');
      }
    });
  }

  function escapeHTMLAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escapeHTMLContent(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // ──── Client-Side Product Grid Filtering ────────────────────────────────
  // Each product card has data-scalp-types, data-concerns, data-benefits,
  // data-product-status, data-product-type attributes. We show/hide
  // based on the active filter state. No network requests.
  //
  // Logic: AND between categories, OR within a category.

  var GRID_SECTION_ID = 'cust-v6-product-grid';

  // ──── SRA Filtering via /collections/all ─────────────────────────────────
  // Uses Shopify's native server-side filtering — same as /collections/all page.
  // Fetches the existing main-collection-product-grid section which is on
  // both live and draft themes, extracts product items, injects into our grid.

  var SRA_SOURCE_SECTION = 'main-collection-product-grid';
  var FILTER_DATA_SECTION = 'cust-v6-filter-data';
  var fetchAbort = null;
  var isFirstRun = true;
  var liveAvailabilityApplied = false;

  // Shared helper — appends Shopify filter params from current state
  function buildShopifyFilterParams(p) {
    if (state.scalp_types.length)     state.scalp_types.forEach(function (v) { p.append('filter.p.m.custom.scalp_type', v); });
    if (state.concerns.length)        state.concerns.forEach(function (v) { p.append('filter.p.m.custom.shop_by_concern', v); });
    if (state.benefits.length)        state.benefits.forEach(function (v) { p.append('filter.p.m.custom.shop_by_benefit', v); });
    if (state.product_types.length)   state.product_types.forEach(function (v) { p.append('filter.p.product_type', v); });
    if (state.hair_likenesses.length) state.hair_likenesses.forEach(function (v) { p.append('filter.p.m.custom.hair_likeness', v); });
    if (state.scents.length)          state.scents.forEach(function (v) { p.append('filter.p.m.custom.product_scent', v); });
    if (state.shopping_missions.length) state.shopping_missions.forEach(function (v) { p.append('filter.p.m.custom.shopping_mission', v); });
    if (state.sort_by) {
      if (isFunctionalSort(state.sort_by)) {
        p.append('sort_by', FUNCTIONAL_SORT_MAP[state.sort_by]);
      } else {
        p.append('filter.p.m.custom.product_status', state.sort_by);
      }
    }
    return p;
  }

  // Maps Shopify filter param_name → our pill key
  var SHOPIFY_PARAM_TO_PILL = {
    'filter.p.m.custom.scalp_type':         'scalp_type',
    'filter.p.m.custom.shop_by_concern':    'concern',
    'filter.p.m.custom.shop_by_benefit':    'benefit',
    'filter.p.product_type':                'product_type',
    'filter.p.m.custom.product_status':     'sort_by',
    'filter.p.m.custom.hair_likeness':      'hair_likeness',
    'filter.p.m.custom.product_scent':      'scent',
    'filter.p.m.custom.shopping_mission':   'shopping_mission'
  };

  function updatePillAvailability(filterDataHtml) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(filterDataHtml, 'text/html');
    var script = doc.querySelector('[data-v6-filter-defs]');
    if (!script) return;

    var defs;
    try { defs = JSON.parse(script.textContent); } catch (e) { return; }
    if (!defs || !defs.filters) return;

    // NOTE: countMap is keyed on filter value LABEL (v.label).
    // The popover/sheet/sort markup also uses v.label as both the visible
    // text AND the input value / data-value attribute, which works for
    // Shopify metafield list-of-values where label === value.
    // If a non-list metafield (e.g. swatch, color picker) is ever added
    // to the filter bar, the lookup will silently return 0 for every
    // option. In that case, change the countMap to key on v.value
    // and update the static Liquid markup to emit data-value="v.value".
    var countMap = {};
    defs.filters.forEach(function (f) {
      var pillKey = SHOPIFY_PARAM_TO_PILL[f.param];
      if (!pillKey) return;
      countMap[pillKey] = {};
      f.values.forEach(function (v) {
        countMap[pillKey][v.label] = v.count;
      });
    });

    // Update popover options — derive isSelected from committed state, not DOM
    document.querySelectorAll('[data-v-popover]').forEach(function (popover) {
      var pillKey = popover.getAttribute('data-v-popover');
      var counts = countMap[pillKey];
      if (!counts) return;

      popover.querySelectorAll('.v-popover__option').forEach(function (opt) {
        var input = opt.querySelector('[data-option]');
        if (!input) return;
        var val = input.value;
        var c = counts[val] || 0;
        var stateKey = PILL_TO_STATE[pillKey];
        var isSelected;
        if (pillKey === 'sort_by') {
          isSelected = state.sort_by === val;
        } else {
          isSelected = stateKey && state[stateKey] && state[stateKey].indexOf(val) !== -1;
        }

        if (c === 0 && !isSelected) {
          opt.classList.add('is-unavailable');
          opt.setAttribute('aria-disabled', 'true');
        } else {
          opt.classList.remove('is-unavailable');
          opt.removeAttribute('aria-disabled');
        }
      });
    });

    // Update sheet chips — derive isSelected from committed state
    document.querySelectorAll('[data-sheet-chip]').forEach(function (chip) {
      var pillKey = chip.getAttribute('data-category');
      var val = chip.getAttribute('data-value');
      var counts = countMap[pillKey];
      if (!counts) return;
      var c = counts[val] || 0;
      var stateKey = PILL_TO_STATE[pillKey];
      var isSelected = stateKey && state[stateKey] && state[stateKey].indexOf(val) !== -1;

      if (c === 0 && !isSelected) {
        chip.classList.add('is-unavailable');
        chip.setAttribute('aria-disabled', 'true');
      } else {
        chip.classList.remove('is-unavailable');
        chip.removeAttribute('aria-disabled');
      }
    });

    // Update sort row buttons — derive isSelected from committed state
    var sortCounts = countMap['sort_by'];
    if (sortCounts) {
      document.querySelectorAll('[data-sort-btn]').forEach(function (btn) {
        var val = btn.getAttribute('data-sort-value');
        var c = sortCounts[val] || 0;
        var isSelected = state.sort_by === val;

        if (c === 0 && !isSelected) {
          btn.classList.add('is-unavailable');
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.classList.remove('is-unavailable');
          btn.removeAttribute('aria-disabled');
        }
      });
    }

    // Update sheet sort_by radios (FIX 3)
    if (sortCounts) {
      document.querySelectorAll('[data-sheet-option][data-category="sort_by"]').forEach(function (input) {
        var label = input.closest('.v-sheet__radio');
        if (!label) return;
        var val = input.value;
        var c = sortCounts[val] || 0;
        var isSelected = state.sort_by === val;
        if (c === 0 && !isSelected) {
          label.classList.add('is-unavailable');
          label.setAttribute('aria-disabled', 'true');
        } else {
          label.classList.remove('is-unavailable');
          label.removeAttribute('aria-disabled');
        }
      });
    }

    // Functional sorts (Price: Low/High) must NEVER be marked unavailable
    Object.keys(FUNCTIONAL_SORT_MAP).forEach(function (label) {
      document.querySelectorAll('[data-sort-btn][data-sort-value="' + label + '"]').forEach(function (btn) {
        btn.classList.remove('is-unavailable');
        btn.removeAttribute('aria-disabled');
      });
      document.querySelectorAll('.v-popover__option [data-option][value="' + label + '"]').forEach(function (input) {
        var opt = input.closest('.v-popover__option');
        if (opt) { opt.classList.remove('is-unavailable'); opt.removeAttribute('aria-disabled'); }
      });
      document.querySelectorAll('[data-sheet-option][data-category="sort_by"][value="' + label + '"]').forEach(function (input) {
        var lbl = input.closest('.v-sheet__radio');
        if (lbl) { lbl.classList.remove('is-unavailable'); lbl.removeAttribute('aria-disabled'); }
      });
    });
  }

  function resetPillAvailability() {
    document.querySelectorAll('.is-unavailable').forEach(function (el) {
      el.classList.remove('is-unavailable');
      el.removeAttribute('aria-disabled');
    });
    liveAvailabilityApplied = false;
  }

  // ──── Priority sort ──────────────────────────────────────────────────────
  function sortGridByPriority(grid) {
    if (!grid) return;
    if (isFunctionalSort(state.sort_by)) return;

    var items = Array.prototype.slice.call(grid.children);
    if (items.length < 2) return;

    items.sort(function (a, b) {
      var pa = parseInt(a.getAttribute('data-filter-priority'), 10);
      var pb = parseInt(b.getAttribute('data-filter-priority'), 10);
      if (isNaN(pa)) pa = 50;
      if (isNaN(pb)) pb = 50;
      if (pa !== pb) return pb - pa;

      var ra = parseFloat(a.getAttribute('data-loox-rating')) || 0;
      var rb = parseFloat(b.getAttribute('data-loox-rating')) || 0;
      if (ra !== rb) return rb - ra;

      var ca = parseInt(a.getAttribute('data-loox-count'), 10) || 0;
      var cb = parseInt(b.getAttribute('data-loox-count'), 10) || 0;
      if (ca !== cb) return cb - ca;

      var ta = (a.getAttribute('data-product-title') || '').toLowerCase();
      var tb = (b.getAttribute('data-product-title') || '').toLowerCase();
      return ta < tb ? -1 : ta > tb ? 1 : 0;
    });

    // Pair shampoo + conditioner: move each conditioner right after its matching shampoo
    items = pairShampooConditioner(items);

    var frag = document.createDocumentFragment();
    items.forEach(function (it) { frag.appendChild(it); });
    grid.appendChild(frag);
  }

  // ──── Shampoo/Conditioner pairing ──────────────────────────────────────
  // After sorting, find conditioner bars and move them right after their
  // matching shampoo bar so pairs stay together in the grid.
  function pairShampooConditioner(items) {
    // Extract a "family key" from a product title by stripping known suffixes
    function familyKey(title) {
      return title
        .replace(/\s*\|.*$/, '')           // strip " | VIORI"
        .replace(/\s*[–—-]\s.*$/, '')      // strip " – All Hair Types"
        .replace(/\bconditioner\s*bar\b/i, '')
        .replace(/\bshampoo\s*bar\b/i, '')
        .replace(/\bconditioner\b/i, '')
        .replace(/\bshampoo\b/i, '')
        .trim()
        .toLowerCase();
    }

    function isConditioner(title) {
      return /conditioner/i.test(title);
    }

    function isShampoo(title) {
      return /shampoo/i.test(title) && !/conditioner/i.test(title);
    }

    // Build result array: for each shampoo, insert its conditioner pair right after
    var result = items.slice();
    var moved = {};

    for (var i = 0; i < result.length; i++) {
      var title = (result[i].getAttribute('data-product-title') || '');
      if (!isShampoo(title)) continue;

      var key = familyKey(title);
      if (!key) continue;

      // Look for matching conditioner elsewhere in the array
      for (var j = 0; j < result.length; j++) {
        if (j === i || j === i + 1) continue;
        var cTitle = (result[j].getAttribute('data-product-title') || '');
        if (!isConditioner(cTitle)) continue;
        if (familyKey(cTitle) !== key) continue;
        if (moved[j]) continue;

        // Move conditioner to position right after the shampoo
        var conditioner = result.splice(j, 1)[0];
        var insertAt = j < i ? i : i + 1;
        result.splice(insertAt, 0, conditioner);
        moved[insertAt] = true;
        break;
      }
    }

    return result;
  }

  // ──── Pagination link rewriter ─────────────────────────────────────────
  // Stiletto's pagination snippet emits links with Shopify filter URL
  // params (filter.v.m.custom.scalp_type=Oily). The V6 controller reads
  // state from V6 internal params (scalp_type=Oily). Rewrite each link's
  // href to use the current URL's V6 params plus the link's own page
  // number so navigation lands on the correct filtered page.
  function rewritePaginationLinks(paginationEl) {
    var links = paginationEl.querySelectorAll('a[href]');
    Array.prototype.forEach.call(links, function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.origin);
        var pageVal = u.searchParams.get('page');
        var newQs = new URLSearchParams(window.location.search);
        if (pageVal) newQs.set('page', pageVal);
        else newQs.delete('page');
        a.setAttribute('href', u.pathname + (newQs.toString() ? '?' + newQs.toString() : ''));
      } catch (_) { /* keep original href on parse failure */ }
    });
  }

  // ──── Universal Best Sellers fallback helpers ──────────────────────────
  // Called when the V6 product grid would otherwise render zero products.
  // The fallback's job is to keep something on screen and let the visitor
  // continue browsing — see CLAUDE.md "Beauty Expert MUST find an output"
  // and the project_v6_build_status auto-memory entry.
  function fireFallbackBeacon(prevState) {
    // GA4 / dataLayer push — picked up by the gtag bridge in theme.liquid.
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({
          event: 'v6_filter_fallback_fired',
          // Snapshot of what the visitor had selected when the fallback
          // fired, so we can spot patterns (e.g. specific filter combos
          // that systematically yield zero).
          v6_dropped_filters: {
            sort_by: prevState.sort_by || '',
            scalp_types: (prevState.scalp_types || []).slice(),
            concerns: (prevState.concerns || []).slice(),
            benefits: (prevState.benefits || []).slice(),
            product_types: (prevState.product_types || []).slice(),
            hair_likenesses: (prevState.hair_likenesses || []).slice(),
            scents: (prevState.scents || []).slice(),
            shopping_missions: (prevState.shopping_missions || []).slice()
          }
        });
      }
    } catch (e) { console.warn('[VioriFilters] fallback beacon failed:', e); }

    // Synchronous CustomEvent for any in-page listeners (Beauty Expert
    // chat panel can subscribe if it wants to acknowledge the fallback).
    try {
      window.dispatchEvent(new CustomEvent('v6:filterFallbackFired', {
        detail: { previousState: prevState }
      }));
    } catch (e) { /* CustomEvent unsupported — no-op */ }
  }

  function showFallbackNotice(gridSection) {
    // Reuse a dedicated notice element if the section template provides one;
    // otherwise create one just-in-time and stash it inside the section so
    // re-renders don't multiply the DOM. The notice is intentionally short
    // and warm — it never says "no match" or "we couldn't find" because
    // the visitor's request might have been perfectly reasonable.
    var notice = gridSection.querySelector('[data-v6-fallback-notice]');
    if (!notice) {
      notice = document.createElement('div');
      notice.setAttribute('data-v6-fallback-notice', '');
      notice.className = 'v6-fallback-notice';
      notice.style.cssText = 'padding:12px 16px;margin:0 0 12px;font-size:14px;color:#444;background:#faf6ee;border-radius:6px;text-align:center;';
      var grid = gridSection.querySelector('[data-v6-grid]');
      if (grid && grid.parentNode) grid.parentNode.insertBefore(notice, grid);
    }
    notice.textContent = 'Showing our best sellers while you explore.';
    notice.style.display = '';
    // Auto-dismiss after the next user interaction with the filter bar.
    var dismiss = function () {
      if (notice && notice.parentNode) notice.style.display = 'none';
      window.removeEventListener('vioriFiltersChanged', dismiss);
    };
    // Defer a tick so the change that triggered the fallback doesn't
    // immediately dismiss the notice we just rendered.
    setTimeout(function () {
      window.addEventListener('vioriFiltersChanged', dismiss, { once: true });
    }, 0);
  }

  function fetchFilteredProducts() {
    // Skip the boot call only when no filters are active. If filters are
    // already in the URL on page load (ad landing, refresh, or back-nav),
    // we still need to fetch immediately so the grid and pagination
    // reflect filter state instead of the unfiltered server render.
    if (isFirstRun) {
      isFirstRun = false;
      if (totalActive() === 0) return;
    }

    var gridSection = document.querySelector('[data-section-id="' + GRID_SECTION_ID + '"]');
    if (!gridSection) return;

    var grid = gridSection.querySelector('[data-v6-grid]');
    var emptyEl = gridSection.querySelector('[data-v6-grid-empty]');
    var countEl = gridSection.querySelector('[data-v6-grid-count]');
    var filterBarCount = document.querySelector('[data-v6-product-count]');

    // Check if any filters active
    var hasFilters = false;
    MULTI_KEYS.forEach(function (k) { if (state[k] && state[k].length) hasFilters = true; });
    if (state.sort_by) hasFilters = true;

    if (!hasFilters) {
      // No filters — show all items, restore original grid
      if (gridSection._originalHTML && grid) {
        grid.innerHTML = gridSection._originalHTML;
      }
      // Restore original pagination markup (server-rendered, unfiltered).
      var existingPagination = gridSection.querySelector('[data-v6-grid-pagination]');
      if (existingPagination && gridSection._originalPaginationHTML !== undefined) {
        existingPagination.innerHTML = gridSection._originalPaginationHTML;
        existingPagination.style.display = '';
      }
      sortGridByPriority(grid);
      gridSection.querySelectorAll('[data-product-item]').forEach(function (el) { el.hidden = false; });
      if (emptyEl) emptyEl.style.display = 'none';
      var total = gridSection.querySelectorAll('[data-product-item]').length;
      if (countEl) countEl.textContent = total + ' products';
      if (filterBarCount) filterBarCount.textContent = 'Showing ' + total + ' products';
      resetPillAvailability();
      processTopMatches(getState());
      return;
    }

    // Save original grid HTML on first filter
    if (!gridSection._originalHTML && grid) {
      gridSection._originalHTML = grid.innerHTML;
    }

    // Build Shopify filter URL — fetch product grid, V6 grid (for the
    // pagination element), filter counts, top matches, pattern A reviews.
    var params = new URLSearchParams();
    params.set('sections', SRA_SOURCE_SECTION + ',' + FILTER_DATA_SECTION + ',cust-v6-top-matches,cust-v6-pattern-a-reviews,cust-v6-product-grid');
    buildShopifyFilterParams(params);

    // Pass through the page param from current URL so pagination clicks
    // land on the correct filtered page.
    var currentPage = new URLSearchParams(window.location.search).get('page');
    if (currentPage) params.set('page', currentPage);

    var url = '/collections/all?' + params.toString();

    // Loading state
    if (grid) grid.style.opacity = '0.3';

    // Abort previous
    if (fetchAbort) { try { fetchAbort.abort(); } catch (e) {} }
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    fetchAbort = controller;

    // ──── Multi-page SRA collection ──────────────────────────────────
    // Stiletto's main-collection-product-grid paginates at
    // rows × columns_desktop (currently 4 × 4 = 16 per page). Any filter
    // combination matching more than 16 products spills onto page 2+ of
    // the SRA response, and those tail matches were silently disappearing
    // from the V6 grid. The Terrace Garden Moisturizing Rice Water S/C
    // (Dry Scalp / Dry Hair) sat on page 2 of the Dry filter and never
    // reached `productItems`. Walk paginate.next links until exhausted
    // so the priority sort below sees every match.
    var parser = new DOMParser();
    var SRA_PAGE_CAP = 7; // 7 × 16 = 112, exceeds full catalog (~106)

    function findNextPageNum(parsedDoc) {
      // Stiletto's main-collection-product-grid renders standard numeric
      // pagination: `<a class="pagination__navigation-button--next" href=".?page=N">`.
      // Some Stiletto sections (load-more pattern) use `data-click-to-load`.
      // Try both, in priority order. If neither exists, page 1 was the last page.
      var link =
        parsedDoc.querySelector('a.pagination__navigation-button--next[href]') ||
        parsedDoc.querySelector('a[data-click-to-load][href]');
      if (!link) return null;
      var href = link.getAttribute('href') || '';
      var qs = href.split('?')[1] || '';
      var p = new URLSearchParams(qs).get('page');
      // Numeric guard: if the href has no `page=` param, bail rather than send
      // `page=null` to Shopify (which would echo back the same first page).
      return p && /^\d+$/.test(p) ? p : null;
    }

    function fetchSourcePage(pageNum) {
      var p = new URLSearchParams(url.split('?')[1] || '');
      // Pages 2+ only need the paginated source section. The other
      // sections (filter data, top matches, pattern A, V6 grid) are
      // not paginated and were already fetched on page 1.
      p.set('sections', SRA_SOURCE_SECTION);
      p.set('page', pageNum);
      return fetch('/collections/all?' + p.toString()).then(function (r) {
        return r.json();
      });
    }

    function collectMorePages(parsedDoc, accumulatedItems, depth) {
      if (depth > SRA_PAGE_CAP) return Promise.resolve(accumulatedItems);
      var nextPage = findNextPageNum(parsedDoc);
      if (!nextPage) return Promise.resolve(accumulatedItems);
      return fetchSourcePage(nextPage)
        .then(function (pageJson) {
          var pageHtml = pageJson[SRA_SOURCE_SECTION] || '';
          if (!pageHtml) return accumulatedItems;
          var pageDoc = parser.parseFromString(pageHtml, 'text/html');
          Array.prototype.forEach.call(
            pageDoc.querySelectorAll('.v-pcard, .product-item'),
            function (it) { accumulatedItems.push(it); }
          );
          return collectMorePages(pageDoc, accumulatedItems, depth + 1);
        })
        .catch(function (e) {
          // Tail-page failure shouldn't kill the whole render — degrade
          // to whatever we have so far.
          if (e && e.name === 'AbortError') throw e;
          console.warn('[VioriFilters] supplemental SRA page fetch failed:', e);
          return accumulatedItems;
        });
    }

    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json[SRA_SOURCE_SECTION];
        if (!html) {
          if (grid) grid.style.opacity = '1';
          console.warn('[VioriFilters] SRA returned null for', SRA_SOURCE_SECTION);
          return;
        }

        // Parse the collection grid HTML and extract product items from
        // page 1.
        var doc = parser.parseFromString(html, 'text/html');
        var initialItems = Array.prototype.slice.call(
          doc.querySelectorAll('.v-pcard, .product-item')
        );

        // Collect any tail pages (paginate.next walk), then continue with
        // the original render path against the combined item list.
        return collectMorePages(doc, initialItems, 1).then(function (allItems) {
          return continueRender(json, allItems);
        });
      })
      .catch(function (e) {
        if (e.name === 'AbortError') return;
        console.error('[VioriFilters] SRA fetch failed:', e);
        if (grid) grid.style.opacity = '1';
      });

    function continueRender(json, allItems) {
      // Cap to the V6 section's own max_products setting. The SRA source
      // is Stiletto's main collection grid — it doesn't know about our
      // V6 limit, so we have to enforce it here.
      //
      // ⚠ Order matters: render the FULL set first, run sortGridByPriority
      // on every match, THEN trim to maxProducts. The previous order
      // (slice → sort) caused homepage/collection divergence: when an
      // Oily filter returned 16 products, the homepage's
      // data-max-products=10 lopped off ranks 11-16 BEFORE priority sort
      // ran, so the high-priority Oily-specific products (Volumizing Rice
      // Water, Tea Tree for Oily) that happened to sit at source ranks
      // 11-14 never got a chance to bubble up. The collection page, with
      // data-max-products=48, never tripped the truncation, so its
      // priority sort saw the full set and ranked those products into
      // slots 4-7 — visibly different from the homepage.
      var maxProducts = parseInt(gridSection.getAttribute('data-max-products') || '0', 10);

        if (grid) {
          grid.innerHTML = '';
          if (allItems.length > 0) {
            allItems.forEach(function (item) {
              grid.appendChild(item.cloneNode(true));
            });
            if (emptyEl) emptyEl.style.display = 'none';
            // Successful render — clear the fallback guard so the next
            // user-initiated 0-result triggers a fresh fallback.
            gridSection._fallbackInFlight = false;
          } else {
            // ──── Universal Best Sellers fallback ─────────────────────────
            // Bryce's hard rule: a product surface MUST never show "no
            // products match". If the active filter set returns zero, clear
            // every filter, sort by Best Sellers, refetch, and show a quiet
            // notice. Guarded by `_fallbackInFlight` so we don't loop on a
            // truly-empty catalog (rare).
            if (!gridSection._fallbackInFlight) {
              gridSection._fallbackInFlight = true;
              fireFallbackBeacon(getState());
              showFallbackNotice(gridSection);
              clearAll();
              setSort('best-selling');
              // clearAll + setSort are debounced via scheduleNotify; the
              // subscriber wired below will refetch automatically. Keep
              // the grid faded until that completes.
              return;
            }
            // Already in fallback and STILL empty — last-ditch backstop.
            // ADR 0007 / 2026-05-08: a product surface MUST NEVER render
            // an error or "no match" state. If the fallback's refetch also
            // came back empty (race with bot mid-fallback, sort_by garbage,
            // network blip, etc.), restore the originally server-rendered
            // grid (which is the unfiltered Best Sellers set Shopify
            // produced from the collection's default sort) and present it
            // as the visible result. Empty element stays hidden — no text
            // ever shown to the visitor.
            if (gridSection._originalHTML) {
              grid.innerHTML = gridSection._originalHTML;
              sortGridByPriority(grid);
              if (maxProducts > 0 && grid.children.length > maxProducts) {
                while (grid.children.length > maxProducts) {
                  grid.removeChild(grid.lastChild);
                }
              }
              var restoredCount = grid.querySelectorAll('[data-product-item], .v-pcard, .product-item').length;
              var restoredLabel = 'Showing ' + restoredCount + ' product' + (restoredCount !== 1 ? 's' : '');
              if (countEl) countEl.textContent = restoredLabel;
              if (filterBarCount) filterBarCount.textContent = restoredLabel;
              grid.style.opacity = '1';
              grid.dispatchEvent(new CustomEvent('v6:cards-rendered', { bubbles: true }));
            }
            if (emptyEl) emptyEl.style.display = 'none';
            gridSection._fallbackInFlight = false;
            return;
          }

          // Sort the FULL set by filter_priority (then rating, count, title)
          // and pair shampoo↔conditioner siblings, BEFORE truncating.
          sortGridByPriority(grid);

          // Now trim to maxProducts by removing surplus children from the
          // tail. By this point the highest-priority items occupy the head
          // of the grid, so dropping the tail preserves the right products.
          if (maxProducts > 0 && grid.children.length > maxProducts) {
            while (grid.children.length > maxProducts) {
              grid.removeChild(grid.lastChild);
            }
          }

          grid.style.opacity = '1';

          // Notify V6 quick-add / view-toggle that new cards were injected
          grid.dispatchEvent(new CustomEvent('v6:cards-rendered', { bubbles: true }));
        }

        // Filter-bar count reflects the TOTAL matched, not the cap, so users
        // know how many products they could see if the cap were higher.
        var count = allItems.length;
        var label = 'Showing ' + count + ' product' + (count !== 1 ? 's' : '');
        if (countEl) countEl.textContent = label;
        if (filterBarCount) filterBarCount.textContent = label;

        // ──── Pagination swap ────────────────────────────────────────────
        // The V6 product grid section renders the pagination snippet when
        // its `show_pagination` setting is on. Pull that element from the
        // SRA response, rewrite its links to use V6 internal params, and
        // swap into the existing pagination container.
        var v6GridHtml = json['cust-v6-product-grid'];
        var existingPagination = gridSection.querySelector('[data-v6-grid-pagination]');
        if (existingPagination) {
          if (gridSection._originalPaginationHTML === undefined) {
            gridSection._originalPaginationHTML = existingPagination.innerHTML;
          }
          if (v6GridHtml) {
            var v6Doc = parser.parseFromString(v6GridHtml, 'text/html');
            var newPagination = v6Doc.querySelector('[data-v6-grid-pagination]');
            if (newPagination) {
              rewritePaginationLinks(newPagination);
              existingPagination.innerHTML = newPagination.innerHTML;
              existingPagination.style.display = '';
            } else {
              // Single page or zero results — hide pagination
              existingPagination.innerHTML = '';
              existingPagination.style.display = 'none';
            }
          }
        }

        // Parse filter counts from cust-v6-filter-data and update pill availability
        var filterDataHtml = json[FILTER_DATA_SECTION];
        if (filterDataHtml) {
          updatePillAvailability(filterDataHtml);
          liveAvailabilityApplied = true;
        }

        // Swap Top Matches staging container if SRA returned it
        var topMatchesHtml = json['cust-v6-top-matches'];
        if (topMatchesHtml) {
          var tmParser = new DOMParser();
          var tmDoc = tmParser.parseFromString(topMatchesHtml, 'text/html');
          var newStaging = tmDoc.querySelector('[data-top-matches-staging]');
          var existingSection = document.querySelector('[data-section="cust-v6-top-matches"]');
          if (newStaging && existingSection) {
            var oldStaging = existingSection.querySelector('[data-top-matches-staging]');
            if (oldStaging) oldStaging.innerHTML = newStaging.innerHTML;
          }
        }

        /* Swap Pattern A Reviews staging BEFORE processTopMatches runs so
           the vioriTopMatchesRendered event Pattern A listens for can find
           the freshly-staged cards. Previously this swap happened AFTER
           processTopMatches, which is why Pattern A and Top Matches showed
           different products on filter changes. */
        var parHtml = json['cust-v6-pattern-a-reviews'];
        if (parHtml) {
          var parParser = new DOMParser();
          var parDoc = parParser.parseFromString(parHtml, 'text/html');
          var newParStaging = parDoc.querySelector('[data-pattern-a-staging]');
          var existingPar = document.querySelector('[data-section="cust-v6-pattern-a-reviews"]');
          if (newParStaging && existingPar) {
            var oldParStaging = existingPar.querySelector('[data-pattern-a-staging]');
            if (oldParStaging) oldParStaging.innerHTML = newParStaging.innerHTML;
          }
        }

        processTopMatches(getState());
    }
  }

  // Wire: on any filter change, fetch filtered products from Shopify
  subscribe(function () {
    fetchFilteredProducts();
  });

  // Wire: "Clear All Filters" button inside the grid empty state
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-action="clear-filters"]')) {
      clearAll();
    }
  });

  // ──── Hero filter-tag pills ─────────────────────────────────────────────
  // Updates hero chip pills to reflect active filter state
  subscribe(function (snap) {
    var container = document.querySelector('[data-v6-hero-tags]');
    if (!container) return;

    var tags = [];
    if (snap.scalp_types && snap.scalp_types.length) {
      tags.push('FOR ' + snap.scalp_types[0].toUpperCase() + ' SCALPS');
    }
    if (snap.concerns && snap.concerns.length) {
      tags.push('+ ' + snap.concerns[0].toUpperCase());
    }
    if (snap.benefits && snap.benefits.length) {
      tags.push('+ ' + snap.benefits[0].toUpperCase());
    }

    var spans = container.querySelectorAll('.v-hero__chip-tag');
    spans.forEach(function (span, i) {
      if (i < tags.length) {
        span.textContent = tags[i];
        span.hidden = false;
      } else {
        span.textContent = '';
        span.hidden = true;
      }
    });

    container.hidden = tags.length === 0;
  });

  // Carousel removed — rows scroll normally
  function initCarousels() {}

  // ──── Top Matches processor ─────────────────────────────────────────────
  function processTopMatches(snap) {
    // Always update the V6 grid title — it lives outside the Top Matches section
    // but uses the same filter-driven naming.
    updateGridTitle(snap);
    updateGridViewAllBottom();

    var sectionRoot = document.querySelector('[data-section="cust-v6-top-matches"]');
    if (!sectionRoot) return;

    var staging = sectionRoot.querySelector('[data-top-matches-staging]');
    var track = sectionRoot.querySelector('[data-top-matches-track]');
    if (!staging || !track) return;

    updateTopMatchesTitle(sectionRoot, snap);
    updateTopMatchesViewAll(sectionRoot);

    var picks = pickTopMatches(staging, snap);

    track.innerHTML = '';
    picks.forEach(function (card, idx) {
      var rank = idx + 1;
      /* Rank 1 uses the 'hero' variant (large card with media + body).
         Ranks 2-5 use the 'list' variant (compact thumb + info row).
         On desktop the list variants stack down a right column next to
         the hero (see CSS @media min-width 768px). On mobile they
         stack as a single column under the hero. */
      var mode = (rank === 1) ? 'hero' : 'list';
      var clone = staging.querySelector('[data-handle="' + card.dataset.handle + '"][data-mode="' + mode + '"]');
      if (!clone) return;
      var instance = clone.cloneNode(true);
      instance.removeAttribute('hidden');
      instance.setAttribute('data-rank', String(rank));
      instance.classList.add('v-topm-card--rank-' + rank);
      // Update rank badge
      var badges = instance.querySelectorAll('.v-topm-card__rank');
      badges.forEach(function (b) { b.textContent = rank; });
      track.appendChild(instance);
    });

    // Re-bind quick-add on new cards
    track.dispatchEvent(new CustomEvent('v6:cards-rendered', { bubbles: true }));

    /* Tell Pattern A Reviews (and any other section that wants to mirror
       the 3 Top Picks) that we're done rendering. Pattern A listens for
       this and re-runs its render, picking the same 3 product handles. */
    window.dispatchEvent(new CustomEvent('vioriTopMatchesRendered', {
      detail: {
        handles: picks.map(function (c) { return c.getAttribute('data-handle'); }).filter(Boolean)
      }
    }));
  }

  function pickTopMatches(staging, snap) {
    var allCards = Array.prototype.slice.call(staging.querySelectorAll('[data-mode="hero"]'));

    function sortByPriority(a, b) {
      var pa = parseInt(a.getAttribute('data-filter-priority') || '0', 10);
      var pb = parseInt(b.getAttribute('data-filter-priority') || '0', 10);
      if (pb !== pa) return pb - pa;
      var ra = parseFloat(a.getAttribute('data-loox-rating') || '0');
      var rb = parseFloat(b.getAttribute('data-loox-rating') || '0');
      if (rb !== ra) return rb - ra;
      return parseInt(b.getAttribute('data-loox-reviews') || '0', 10) - parseInt(a.getAttribute('data-loox-reviews') || '0', 10);
    }

    function scentKey(card) {
      // Empty / unscented products don't dedup against each other — return ''
      // so the picker doesn't treat all unscented items as one family.
      return (card.getAttribute('data-product-scent') || '').trim().toLowerCase();
    }

    /* Within-scent product-type priority. Lower number wins.
       Bryce's rule (Apr 2026): when two products share a scent, surface
       them in this order regardless of filter_priority:
         1. Shampoo
         2. Conditioner
         3. Sugar Scrub
         4. Body Butter
         5. Anything else
       Substring match on data-product-type, with handle as fallback for
       products where the type field is missing or unusual. */
    function typeRank(card) {
      var t = (card.getAttribute('data-product-type') || '').toLowerCase();
      var h = (card.getAttribute('data-handle') || '').toLowerCase();
      var s = t + ' ' + h;
      if (s.indexOf('shampoo') !== -1)     return 1;
      if (s.indexOf('conditioner') !== -1) return 2;
      if (s.indexOf('scrub') !== -1)       return 3;
      if (s.indexOf('butter') !== -1)      return 4;
      return 5;
    }

    function sortByTypeThenPriority(a, b) {
      var ta = typeRank(a), tb = typeRank(b);
      if (ta !== tb) return ta - tb;
      return sortByPriority(a, b);
    }

    /* Group cards by scent. Empty-scent cards each become their own
       single-member group so they don't collapse into one fake family. */
    var groups = {};
    var groupOrder = [];
    allCards.forEach(function (c, idx) {
      var sc = scentKey(c);
      var key = sc || ('__empty_' + idx);
      if (!groups[key]) {
        groups[key] = [];
        groupOrder.push(key);
      }
      groups[key].push(c);
    });

    /* For each scent group, the representative is the highest-ranked
       product by [type_rank asc, filter_priority desc, rating desc,
       reviews desc]. Type rank drives the within-scent ordering, so
       Rosemary Shampoo always beats Rosemary Conditioner regardless
       of which has the higher filter_priority. The rest of the group
       goes to `skipped` for backfill. */
    var reps = [];
    var skipped = [];

    groupOrder.forEach(function (key) {
      var sortedGroup = groups[key].slice().sort(sortByTypeThenPriority);
      reps.push(sortedGroup[0]);
      for (var j = 1; j < sortedGroup.length; j++) skipped.push(sortedGroup[j]);
    });

    /* Cross-scent ranking — pure filter_priority/rating/reviews. The
       top scent (e.g. Rosemary at priority 90) shows before the next
       (e.g. Lavender at priority 70). Type rank doesn't apply across
       scent families because the families are already different. */
    reps.sort(sortByPriority);
    /* Bryce 2026-05-05: desktop layout is 1 hero (rank 1) + 4 list
       cards (ranks 2-5), so the picker now returns up to 5 instead of
       the original 3. Mobile keeps the same hero-plus-list look — the
       extra picks just stack as more list rows on phones. */
    var TOP_MATCHES_COUNT = 5;
    var picks = reps.slice(0, TOP_MATCHES_COUNT);

    /* Backfill from `skipped` if there are fewer than TOP_MATCHES_COUNT
       distinct scent families in the filter result (e.g. visitor
       filtered to a single scent). Within the backfill pool we keep
       the type-priority order so a "Rosemary only" filter shows
       Shampoo → Conditioner → Scrub in that order. */
    if (picks.length < TOP_MATCHES_COUNT) {
      skipped.sort(sortByTypeThenPriority);
      while (picks.length < TOP_MATCHES_COUNT && skipped.length > 0) {
        picks.push(skipped.shift());
      }
    }

    /* Defensive fallback — only reachable if allCards.length is below
       TOP_MATCHES_COUNT. */
    if (picks.length < TOP_MATCHES_COUNT) {
      var pickedHandles = {};
      picks.forEach(function (c) { pickedHandles[c.getAttribute('data-handle')] = true; });
      var remaining = allCards.filter(function (c) {
        return !pickedHandles[c.getAttribute('data-handle')];
      }).sort(sortByPriority);
      while (picks.length < TOP_MATCHES_COUNT && remaining.length > 0) {
        picks.push(remaining.shift());
      }
    }

    return picks;
  }

  // Shared list-joiner: 1 → "A", 2 → "A, B", 3+ → "A, B, and C" (Oxford comma)
  function joinList(items) {
    if (!items || items.length === 0) return '';
    if (items.length === 1) return items[0];
    if (items.length === 2) return items[0] + ', ' + items[1];
    var last = items[items.length - 1];
    var rest = items.slice(0, -1);
    return rest.join(', ') + ', and ' + last;
  }

  // Build the dynamic, filter-aware title.
  //   prefix = "Best Sellers" (Top Matches) or "Recommended" (grid)
  //   Order: Likeness → Hair Type → Concerns (all adjectives, get one trailing "Hair")
  //   Benefits → " that needs <list>"
  //   Product Type → omitted from title entirely
  //   Cap: 4 visible tokens. When trimming, drop 3rd benefit before 3rd adjective.
  function buildFilterTitle(prefix, snap) {
    var likeness = snap.hair_likenesses || [];
    var types    = snap.scalp_types || [];
    var concerns = snap.concerns || [];
    var benefits = (snap.benefits || []).slice();

    var adjectives = [].concat(likeness).concat(types).concat(concerns);

    // 4-token cap; prefer to drop 3rd benefit, then 3rd adjective
    while (adjectives.length + benefits.length > 4) {
      if (benefits.length >= 3) benefits.pop();
      else if (adjectives.length > 0) adjectives.pop();
      else break;
    }

    if (adjectives.length === 0 && benefits.length === 0) {
      return escapeHTMLContent(prefix);
    }

    var dynamic = '';
    if (adjectives.length > 0) {
      dynamic = joinList(adjectives) + ' Hair';
    } else {
      dynamic = 'Hair';
    }
    if (benefits.length > 0) {
      dynamic += ' that needs ' + joinList(benefits);
    }

    // Returns HTML: prefix + " for" on the heading row, then the dynamic
    // adjective/benefit phrase wraps to its own row inside a styled span
    // (.v-filter-title__dynamic — Montserrat 400, black ink, pink glow).
    // Sparkles bookend the dynamic phrase. \u2728 keeps the source ASCII.
    // \u00A0 = non-breaking space — keeps "<prefix> for" glued on row 1
    // even if the H2 column gets squeezed by a sibling element.
    return escapeHTMLContent(prefix) + '\u00A0for'
      + '<span class="v-filter-title__dynamic">'
      + '\u2728 ' + escapeHTMLContent(dynamic) + ' \u2728'
      + '</span>';
  }

  function updateTopMatchesTitle(sectionRoot, snap) {
    var titleEl = sectionRoot.querySelector('[data-top-matches-title]');
    if (!titleEl) return;
    titleEl.innerHTML = buildFilterTitle('Best Sellers', snap);
  }

  function updateGridTitle(snap) {
    var titleEls = document.querySelectorAll('[data-v6-grid-title]');
    if (!titleEls.length) return;
    var line = buildFilterTitle('Recommended', snap);
    for (var i = 0; i < titleEls.length; i++) {
      titleEls[i].innerHTML = line;
    }
  }

  // Keep the bottom "View all" link's href in sync with the active filter URL
  // so the destination /collections/all page hydrates with the same filters.
  function updateGridViewAllBottom() {
    var els = document.querySelectorAll('[data-v6-grid-view-all-bottom]');
    if (!els.length) return;
    var dest = '/collections/all' + window.location.search;
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('href', dest);
    }
  }

  function updateTopMatchesViewAll(sectionRoot) {
    var linkEl = sectionRoot.querySelector('[data-top-matches-view-all]');
    if (!linkEl) return;
    linkEl.href = '/collections/all' + window.location.search;
  }

  // ──── Body flag + grid "Start over" CTA wiring ─────────────────────────
  // Toggles `body.v-has-filters` whenever filter state changes so CSS-only
  // elements (e.g. the "Want to start over?" CTA in the product grid
  // section) can show/hide without needing a per-element JS reference.
  // Survives SRA section swaps because the class lives on <body>.
  function syncBodyHasFiltersFlag() {
    if (document.body) {
      document.body.classList.toggle('v-has-filters', totalActive() > 0);
    }
  }
  subscribe(syncBodyHasFiltersFlag);

  // Document-level click delegation for the grid "Start over" button.
  // Survives SRA section swaps. Clears all filters and scrolls to top.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-action="grid-start-over"]');
    if (!btn) return;
    e.preventDefault();
    clearAll();
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); }
    catch (_) { window.scrollTo(0, 0); }
  });

  // ──── Cart attribute writer ───────────────────────────────────────────
  // Mirror active filter URL state into Shopify cart attributes so the
  // context follows the visitor through cart → checkout → order →
  // (via Shopify Flow) customer metafields. Klaviyo's Shopify integration
  // then exposes those customer metafields as profile properties for
  // segmentation.
  //
  // Naming alignment (URL key → cart attribute → customer metafield):
  //   scalp_type        _scalp_type        custom.scalp_type
  //   concern           _shop_by_concern   custom.shop_by_concern
  //   benefit           _shop_by_benefit   custom.shop_by_benefit
  //   hair_likeness     _hair_likeness     custom.hair_likeness
  //   scent             _product_scent     custom.product_scent
  //   shopping_mission  _shopping_mission  custom.shopping_mission
  //
  // Underscore prefix is Shopify's marker for "don't render in cart UI".
  // Values are JSON-encoded array strings — same wire format Shopify
  // metafield API expects for list.single_line_text_field — so Shopify
  // Flow can pass them straight to the customer metafield without
  // transformation.
  //
  // AI Shop 2.0 attribution (Day 4-C, 2026-05-12):
  //   _persona_id  →  ai_shop_persona metaobject handle the visitor
  //                   landed from. Captured when the visitor is on
  //                   /pages/persona?id=<handle>. Shopify auto-carries
  //                   the attribute onto order.note_attributes, and the
  //                   worker /webhooks/order-paid handler increments the
  //                   persona's order_count_authoritative on match.
  var CART_ATTR_MAP = {
    _scalp_type:        'scalp_types',
    _shop_by_concern:   'concerns',
    _shop_by_benefit:   'benefits',
    _hair_likeness:     'hair_likenesses',
    _product_scent:     'scents',
    _shopping_mission:  'shopping_missions'
  };

  var lastCartAttrPayload = null;

  // Read ?id=<handle> when the visitor is on a persona route. Returns
  // the handle string or '' (empty clears the cart attribute, same as
  // an empty filter array). We re-read on every flush rather than
  // caching on boot, so a SPA-style nav between persona pages updates
  // the attribution correctly.
  //
  // Recognised sources, in priority order:
  //   1. window.location.pathname matches a known persona route
  //      (/pages/persona for AI Shop 2.0, /pages/sp-persona for
  //      Store Persona 2.0) AND ?id=<handle> is set.
  //   2. document.body[data-persona-id] is set by the persona section
  //      itself. Future persona routes only need to set this attr.
  var PERSONA_ROUTES = ['/pages/persona', '/pages/sp-persona'];
  function readPersonaIdFromUrl() {
    try {
      if (PERSONA_ROUTES.indexOf(window.location.pathname) !== -1) {
        var id = new URLSearchParams(window.location.search).get('id');
        if (id) return String(id);
      }
      var bodyAttr = document.body && document.body.getAttribute('data-persona-id');
      return bodyAttr ? String(bodyAttr) : '';
    } catch (_) {
      return '';
    }
  }

  function buildCartAttrPayload() {
    var snap = getState();
    var attributes = {};
    Object.keys(CART_ATTR_MAP).forEach(function (cartKey) {
      var stateKey = CART_ATTR_MAP[cartKey];
      var arr = snap[stateKey] || [];
      // Empty string clears the attribute (Shopify removes attrs whose
      // value is blank). Non-empty values go as JSON arrays.
      attributes[cartKey] = arr.length ? JSON.stringify(arr) : '';
    });
    // _persona_id rides alongside the filter attrs. Plain string (not
    // a JSON-encoded array) since it's a single handle, not a multi-
    // select. STICKY semantics: only include the key when we have a
    // value on this page load. Omitting the key on subsequent flushes
    // leaves the previously-written attribute in place, so a visitor
    // who lands on /pages/persona?id=foo and then navigates to a PDP
    // to add to cart still carries foo as the attribution. An empty
    // string would clear it (same convention as the filter attrs).
    var personaId = readPersonaIdFromUrl();
    if (personaId) attributes._persona_id = personaId;
    return attributes;
  }

  function sameCartAttrPayload(a, b) {
    if (!a || !b) return false;
    var keys = Object.keys(a);
    for (var i = 0; i < keys.length; i++) {
      if (a[keys[i]] !== b[keys[i]]) return false;
    }
    return true;
  }

  function postCartUpdate(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update returned ' + r.status);
      return r.json();
    });
  }

  function flushCartAttributes() {
    var attributes = buildCartAttrPayload();
    if (sameCartAttrPayload(attributes, lastCartAttrPayload)) return;
    lastCartAttrPayload = attributes;

    postCartUpdate(attributes).catch(function (err) {
      // CLAUDE.md hard rule: try/catch with one retry after 2s. Failures
      // log but never block any cart operation.
      console.warn('[VioriFilters] cart attr write failed, retrying in 2s:', err);
      setTimeout(function () {
        postCartUpdate(attributes).catch(function (err2) {
          console.error('[VioriFilters] cart attr write failed twice, giving up:', err2);
          // Reset so the next state change retries from scratch.
          lastCartAttrPayload = null;
        });
      }, 2000);
    });
  }

  // Subscribe so every state change flushes. notify() is already
  // debounced 500ms upstream via scheduleNotify, so we don't double-debounce.
  // The boot-time flush happens after readStateFromURL() further down — at
  // this point in the IIFE, state is still empty arrays, so flushing here
  // would just cache an empty payload and the subscribe never fires for
  // URL-hydrated state (readStateFromURL is intentionally quiet).
  subscribe(flushCartAttributes);

  // ──── Internal-link filter propagation ─────────────────────────────────
  // When the visitor clicks an internal link, copy any filter params on
  // the current URL onto the destination so filter state survives nav
  // (e.g. /collections/all?scalp_type=Oily → click logo → land on / with
  // the same param; click hero CTA → land on /collections/all with the
  // CTA's filters pre-applied).
  //
  // Mechanism: pointerdown + click capture-phase listeners mutate the
  // <a>'s href in place. Browser navigation then uses the modified href.
  // pointerdown covers mouse activations (including middle-click new-tab
  // and right-click "open in new tab"); click covers keyboard Enter on a
  // focused link.
  //
  // Skip rules:
  //   - link already has its own filter params  → preserve intent
  //     (hero CTAs intentionally override the inherited state)
  //   - cross-origin, anchor (#frag), mailto:/tel:/javascript:, blob:
  //     → leave alone
  //   - href that won't parse as a URL → leave alone
  var FILTER_PARAM_KEYS = (function () {
    var keys = {};
    Object.keys(URL_KEY_MAP).forEach(function (k) { keys[URL_KEY_MAP[k]] = true; });
    Object.keys(SHOPIFY_PARAM_TO_STATE).forEach(function (k) { keys[k] = true; });
    return keys;
  })();

  function urlHasOwnFilters(u) {
    var has = false;
    u.searchParams.forEach(function (val, key) {
      if (FILTER_PARAM_KEYS[key]) has = true;
    });
    return has;
  }

  function rewriteLinkHref(a) {
    if (!a || !a.getAttribute) return;
    var href = a.getAttribute('href');
    if (!href) return;
    var firstChar = href.charAt(0);
    if (firstChar === '#') return;
    if (/^(mailto|tel|sms|javascript|data|blob):/i.test(href)) return;
    var u;
    try { u = new URL(href, window.location.origin); }
    catch (_) { return; }
    if (u.origin !== window.location.origin) return;
    if (urlHasOwnFilters(u)) return;

    var current = new URLSearchParams(window.location.search);
    var changed = false;
    current.forEach(function (val, key) {
      if (FILTER_PARAM_KEYS[key] && !u.searchParams.has(key)) {
        u.searchParams.set(key, val);
        changed = true;
      }
    });
    if (changed) {
      var qs = u.searchParams.toString();
      a.setAttribute('href', u.pathname + (qs ? '?' + qs : '') + u.hash);
    }
  }

  function onLinkActivate(e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href]') : null;
    if (!a) return;
    rewriteLinkHref(a);
  }

  document.addEventListener('pointerdown', onLinkActivate, true);
  document.addEventListener('click', onLinkActivate, true);

  // ──── Boot ─────────────────────────────────────────────────────────────
  readStateFromURL();

  // Flush cart attrs once after URL hydration so ad-landings (visitor lands
  // with filter params and adds to cart without touching a filter pill) get
  // the state mirrored into cart attributes. Must come AFTER readStateFromURL
  // because that function does not call notify() — it's a quiet hydration —
  // so a flush registered via subscribe() would never fire for URL-driven
  // state alone.
  flushCartAttributes();

  // Sort the initial grid by filter_priority on boot
  var bootGrid = document.querySelector('[data-section-id="' + GRID_SECTION_ID + '"] [data-v6-grid]');
  if (bootGrid) sortGridByPriority(bootGrid);

  // Process top matches on boot
  processTopMatches(getState());

  window.VioriFilters = {
    getState: getState,
    setState: setState,
    toggle: toggle,
    setSort: setSort,
    clearCategory: clearCategory,
    clearAll: clearAll,
    applyFilters: applyFilters,
    subscribe: subscribe,
    activeCount: activeCount,
    totalActive: totalActive,
    bindFilterBar: bindFilterBar,
    fetchFilterDefs: fetchFilterDefs,
    rebuildFilterUI: rebuildFilterUI,
    bindSortRow: bindSortRow,
    initCarousels: initCarousels,
    // Shared dynamic-title formula. Other sections (Pattern A Reviews, etc.)
    // call this with their own prefix so all titles read identically.
    buildFilterTitle: buildFilterTitle,
    // Repopulate the Top Matches track + titles from the current state.
    // Called by the section on shopify:section:load (theme editor reloads).
    refreshTopMatches: function () { processTopMatches(getState()); },
    /* Returns the 3 product handles Top Matches just rendered (or would
       render given the current state). Pattern A Reviews uses this so its
       3 review cards are locked to the same products Top Picks shows.
       Reads from the rendered track first (source of truth for what the
       user sees); falls back to running the picker against the staging
       container if the track isn't populated yet. */
    getTopMatchesHandles: function (snap) {
      var sectionRoot = document.querySelector('[data-section="cust-v6-top-matches"]');
      if (!sectionRoot) return [];
      var track = sectionRoot.querySelector('[data-top-matches-track]');
      if (track) {
        var rendered = Array.prototype.slice.call(track.querySelectorAll('[data-handle]'))
          .map(function (el) { return el.getAttribute('data-handle'); })
          .filter(Boolean);
        // Dedupe (a product can appear in both hero+list cards rendered)
        var seen = {}; var out = [];
        for (var i = 0; i < rendered.length; i++) {
          if (!seen[rendered[i]]) { seen[rendered[i]] = true; out.push(rendered[i]); }
          if (out.length >= 3) break;
        }
        if (out.length > 0) return out;
      }
      var staging = sectionRoot.querySelector('[data-top-matches-staging]');
      if (!staging) return [];
      var picks = pickTopMatches(staging, snap || getState());
      return picks.map(function (c) { return c.getAttribute('data-handle'); }).filter(Boolean);
    }
  };

  lastFiredKey = '';
  notify();

  // Fetch baseline filter counts on boot (for pill availability)
  // Includes current URL filter state so ad-landing URLs get correct counts
  var bootParams = new URLSearchParams();
  bootParams.set('sections', FILTER_DATA_SECTION);
  buildShopifyFilterParams(bootParams);
  var bootPreview = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (bootPreview) bootParams.set('preview_theme_id', bootPreview);
  var bootUrl = '/collections/all?' + bootParams.toString();
  fetch(bootUrl).then(function (r) { return r.json(); }).then(function (json) {
    var html = json[FILTER_DATA_SECTION];
    // Only apply if a user-triggered SRA hasn't already resolved (race guard)
    if (!liveAvailabilityApplied && html) updatePillAvailability(html);
  }).catch(function () {});

})(window, document);
